import {
  ChartColumnIncreasing,
  Crown,
  FerrisWheel,
  Film,
  Joystick,
  Mail,
  Medal,
  Puzzle,
  Settings,
  ShoppingCart,
  Swords,
  TicketPercent,
  Users,
} from 'lucide-react';

import CasinoChip from '@assets/CasinoChip.svg?react';
import Horn from '@assets/Horn.svg?react';

import {
  MANAGEMENT_GROUP,
  SELLS_GROUP,
  HEAD_SUPPORT_GROUP,
  SERVICE_GROUP,
  WRITE_GROUP,
  SUPPORT_GROUP,
} from 'v2/constants';
import { AppRoute } from 'v2/routes';
import { NavigationParent } from 'v2/types';

export const NAVIGATION_ITEMS: NavigationParent[] = [
  {
    title: 'Tournaments',
    icon: Swords,
    group: HEAD_SUPPORT_GROUP,
    children: [
      { title: 'Tournaments', path: AppRoute.TOURNAMENT_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Tournament Groups', path: AppRoute.TOURNAMENT_GROUP_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Tournaments History', path: AppRoute.TOURNAMENTS_HISTORY_PAGE, group: HEAD_SUPPORT_GROUP },
      { title: 'Free Spins', path: AppRoute.PROVIDER_FREE_SPINS_SETTINGS_PAGE, group: WRITE_GROUP },
    ],
  },
  {
    title: 'Casinos',
    icon: CasinoChip,
    group: MANAGEMENT_GROUP,
    children: [
      { title: 'Casinos', path: AppRoute.CASINO_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Partners', path: AppRoute.PARTNER_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
  {
    title: 'Daily Bonuses',
    icon: Medal,
    group: HEAD_SUPPORT_GROUP,
    children: [
      { title: 'Daily Bonuses', path: AppRoute.DAILY_BONUSES_SETTINGS_PAGE, group: WRITE_GROUP },
      { title: 'Distribution Link', path: AppRoute.DISTRIBUTION_LINK_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Entry Rewards', path: AppRoute.ENTRY_REWARDS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Rewards History', path: AppRoute.REWARDS_HISTORY_PAGE, group: HEAD_SUPPORT_GROUP },
    ],
  },
  {
    title: 'Promo Code',
    icon: TicketPercent,
    path: AppRoute.PROMO_CODE_SETTINGS_PAGE,
    group: HEAD_SUPPORT_GROUP,
  },
  {
    title: 'Attractions',
    icon: FerrisWheel,
    group: SERVICE_GROUP,
    children: [
      { title: 'Tickets', path: AppRoute.TICKETS_PAGE, group: SERVICE_GROUP },
      { title: 'Lotteries', path: AppRoute.LOTTERY_SETTINGS, group: MANAGEMENT_GROUP },
      { title: 'Betting', path: AppRoute.BET_SYSTEM_SETTINGS, group: MANAGEMENT_GROUP },
      { title: 'Streamer Wheel', path: AppRoute.STREAMER_WHEEL_SETTINGS_PAGE, group: WRITE_GROUP },
    ],
  },
  {
    title: 'Ads',
    icon: Horn,
    group: MANAGEMENT_GROUP,
    children: [
      { title: 'Ads', path: AppRoute.ADS_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Casino Ads', path: AppRoute.CASINO_ADS_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
  {
    title: 'Levels',
    icon: ChartColumnIncreasing,
    path: AppRoute.LEVEL_SETTINGS_PAGE,
    group: MANAGEMENT_GROUP,
  },
  {
    title: 'VIP System',
    icon: Crown,
    path: AppRoute.VIP_SETTINGS_PAGE,
    group: SELLS_GROUP,
  },
  {
    title: 'Slots',
    icon: Joystick,
    path: AppRoute.PROVIDER_SLOT_SETTINGS_PAGE,
    group: MANAGEMENT_GROUP,
  },
  {
    title: 'Store',
    icon: ShoppingCart,
    path: AppRoute.STORE_SETTINGS_PAGE,
    group: WRITE_GROUP,
  },
  {
    title: 'Video',
    icon: Film,
    path: AppRoute.VIDEO_SETTINGS_PAGE,
    group: MANAGEMENT_GROUP,
  },
  {
    title: 'Users',
    icon: Users,
    group: SUPPORT_GROUP,
    children: [
      { title: 'Referral System', path: AppRoute.REFERRAL_REWARD_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Referral System V2', path: AppRoute.REFERRAL_SYSTEM_V2_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Users', path: AppRoute.USER_SETTINGS_PAGE, group: SUPPORT_GROUP },
      { title: 'Suspicious Users', path: AppRoute.SUSPICIOUS_USERS_PAGE, group: WRITE_GROUP },
      { title: 'Cheaters', path: AppRoute.CHEATER_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
  {
    title: 'App',
    icon: Puzzle,
    group: MANAGEMENT_GROUP,
    children: [
      { title: 'Modal Settings', path: AppRoute.MODAL_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Main Screen Settings', path: AppRoute.MAIN_SCREEN_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'User Guide', path: AppRoute.USER_GUIDES_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Domain Settings', path: AppRoute.DOMAIN_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
  {
    title: 'Mailing',
    icon: Mail,
    group: HEAD_SUPPORT_GROUP,
    children: [
      { title: 'Telegram Bot', path: AppRoute.MAILING_SETTINGS_PAGE, group: SUPPORT_GROUP },
      { title: 'In-App Notifications', path: AppRoute.BROADCAST_NOTIFICATIONS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
  {
    title: 'Settings',
    icon: Settings,
    group: MANAGEMENT_GROUP,
    children: [
      { title: 'Master Keys', path: AppRoute.MASTER_KEY_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'File System', path: AppRoute.FILE_SYSTEM_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
      { title: 'Telegram Bot Settings', path: AppRoute.TELEGRAM_BOT_SETTINGS_PAGE, group: MANAGEMENT_GROUP },
    ],
  },
];
